import React, { useEffect, useState } from "react";
import { Button, Grid, Select, MenuItem, FormControl } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ScaleLoader from "react-spinners/ScaleLoader";
import axios from "axios";
import urlLinks from "../../../UrlLinks";
import styles from "./FilterDrawer.module.scss";
import AutoSelect from "./AutoSelect"; // adjust the import path as needed

const FilterDrawer = ({
  handleClose,
  resetFilters,
  applyFilters,
  filters,
  setFilters,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [allLocationOptions, setAllLocationOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationSearchText, setLocationSearchText] = useState("");
  const [companyTypeSearchText, setCompanyTypeSearchText] = useState("");

  const [companyTypeOptions] = useState([
    { id: 1, name: "Sole Proprietorship" },
    { id: 2, name: "Partnership" },
    { id: 3, name: "Limited Liability Company (LLC)" },
    { id: 4, name: "Private Limited Company (Pvt Ltd)" },
    { id: 5, name: "Public Limited Company (PLC)" },
    { id: 6, name: "One Person Company (OPC)" },
    { id: 7, name: "Corporation (Inc.)" },
    { id: 8, name: "Non-Profit Organization / NGO" },
    { id: 9, name: "Individual, non-registered business" },
  ]);

  // const handleCompanyTypeChange = (event) => {
  //   console.log("event",event);
  //   setFilters((prev) => ({
  //     ...prev,
  //     companyType: event.target.value,
  //   }));
  // };

  const handleReset = () => {
    setFilters((prev) => ({
      ...prev,
      companyType: "",
      location: "",
    }));
    resetFilters();
  };

  const loader = (
    <div className={styles.loaderContainer}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  /** ✅ Fetch all locations on mount */
  const getAllLocationOptions = async () => {
    try {
      const response = await axios.get(`${urlLinks.baseUrl}configmaster/getCities`);
      const cities = response.data?.response ?? [];
      const options = cities.map((item, index) => ({ id: index + 1, name: item }));
      setAllLocationOptions(options);
      setLocationOptions(options); // Show all initially
    } catch (err) {
      console.error("Error fetching locations:", err);
    }
  };

  // Load all locations on mount
  useEffect(() => {
    getAllLocationOptions();
  }, []);

  // Filter locations based on search text
  useEffect(() => {
    if (locationSearchText) {
      const filtered = allLocationOptions.filter((option) =>
        option.name.toLowerCase().includes(locationSearchText.toLowerCase())
      );
      setLocationOptions(filtered);
    } else {
      setLocationOptions(allLocationOptions);
    }
  }, [locationSearchText, allLocationOptions]);

  const drawerContent = (
    <Grid container className={styles.drawerContainer}>
      {/* Header */}
      <Grid container className={styles.header}>
        <div className={styles.headerTitle}>
          <Button onClick={handleClose} className={styles.closeButton}>
            <ArrowForwardIcon />
          </Button>
          <span className={styles.titleText}>Filters</span>
        </div>
        <Button onClick={handleReset} className={styles.resetButton}>
          Reset
        </Button>
      </Grid>

      <div className={styles.divider}></div>

      {/* Filters */}
      <div className={styles.filtersWrapper}>
        {/* ✅ Company Type */}
        <div className={styles.filterRow}>
          <span className={styles.filterLabel}>Company Type</span>
          <AutoSelect
            options={companyTypeOptions}
            filters={filters}
            setFilters={setFilters}
            id="companyType"
            multipleFlag={false}
            onInputChange={(event, value) => setCompanyTypeSearchText(value)}
          />
        </div>

        {/* ✅ Location (AutoSelect with search) */}
        <div className={styles.filterRow}>
          <span className={styles.filterLabel}>Location</span>
          <AutoSelect
            options={locationOptions}
            filters={filters}
            setFilters={setFilters}
            id="location"
            multipleFlag={false}
            onInputChange={(event, value) => setLocationSearchText(value)}
          />
        </div>
      </div>

      <div className={styles.divider}></div>

      {/* Footer */}
      <Grid container className={styles.footer}>
        <Button onClick={handleClose} className={styles.cancelButton}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={applyFilters}
          className={styles.applyButton}
        >
          Apply
        </Button>
      </Grid>
    </Grid>
  );

  return isLoading ? loader : drawerContent;
};

export default FilterDrawer;
